import './App.css';

import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./App.css";
import Home from "./components/home/Home";
import BookingWrapper from "./components/bookingWrapper/BookingWrapper";
import LoginScreen from "./components/login/LoginScreen";
import AppointmentBooking from "./components/appointmentBooking/AppointmentBooking";
import { SalonProvider } from './context/SalonContext';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import ViewBookings from './components/viewBookings/ViewBookings';
import MembershipPlans from "./components/membershipPlans/MembershipPlans";
import MyMemberships from "./components/memberships/MyMemberships";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Terms from "./components/terms/Terms";
import Privacy from "./components/privacy/Privacy";
import Notifications from "./components/notifications/Notifications";
import AdvancePaymentWeb from './components/pay/AdvancePaymentWeb';
import LoyaltyWallet from './components/loyalty/LoyaltyWallet';
import AppointmentDetails from "./components/appointmentDetails/AppointmentDetails"

function AppContent() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <div className="app-container">
      {!isLoginPage && <Header />}
      <main className={isLoginPage ? "content-full" : "content"}>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/home" element={<Home />} />
          <Route path="/salon/:token" element={<BookingWrapper />} />
          <Route path="/login" element={<LoginScreen />} />

          <Route path="/booking" element={
            <ProtectedRoute requireSalon>
              <AppointmentBooking />
            </ProtectedRoute>
          } />

          <Route path="/viewBookings" element={
            <ProtectedRoute requireSalon>
              <ViewBookings />
            </ProtectedRoute>
          } />

          <Route path="/loyaltyWallet" element={
            <ProtectedRoute requireSalon>
              <LoyaltyWallet />
            </ProtectedRoute>
          } />

          <Route path="/membership-plans" element={
            <ProtectedRoute requireSalon>
              <MembershipPlans />
            </ProtectedRoute>
          } />

          <Route path="/my-memberships" element={
            <ProtectedRoute requireSalon>
              <MyMemberships />
            </ProtectedRoute>
          } />

          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/pay/:bookingRef" element={<AdvancePaymentWeb />} />
          <Route path="/appointment/:id" element={<AppointmentDetails />} />
        </Routes>
      </main>
      {!isLoginPage && <Footer className="footer" />}
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
}

function App() {
  return (
    <SalonProvider>
      <AppContent />
    </SalonProvider>
  );
}

export default App;